import React from 'react'
import Button from '../../../common/Button/Button.component'
import AuthFormLayoutComponent from '../../AuthFormLayout/AuthFormLayout.component'

import './PassRecoverySuccess.style.scss'

interface Props {
  onLoginClick: () => void;
}

const block = 'pass-recovery-success'

const PassRecoverySuccessComponent = (props: Props): JSX.Element => {
  const { onLoginClick } = props

  return (
    <AuthFormLayoutComponent 
      title="ВОССТАНОВЛЕНИЕ ПАРОЛЯ" 
      className={block}
    >
      <div className={`${block}__text`}>
        Письмо с ссылкой на восстановление пароля было отправлено на указанный email.
      </div>

      <div className={`auth-form-layout__button`}>
        <Button 
          background="turquoise" 
          onClick={onLoginClick}
          text={'Войти'}
        />
      </div>
    </AuthFormLayoutComponent>
  )
}

export default PassRecoverySuccessComponent